import { render, staticRenderFns } from "./1_documents.vue?vue&type=template&id=78302fb4&scoped=true&"
import script from "./1_documents.vue?vue&type=script&lang=js&"
export * from "./1_documents.vue?vue&type=script&lang=js&"
import style0 from "./1_documents.vue?vue&type=style&index=0&id=78302fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78302fb4",
  null
  
)

export default component.exports